import { EmbeddedDocumentPanel } from 'features/libra/document/EmbeddedDocumentPanel'
import { FC } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
`

/**
 * Workspace panel that hosts the embedded PDF/image viewer. Consumes
 * `useLibraDocument()` internally -- the `LibraDocumentProvider` is mounted by
 * the workspace container.
 */
export const Component: FC = () => {
  return (
    <Container>
      <EmbeddedDocumentPanel />
    </Container>
  )
}
